import { render, staticRenderFns } from "./AccountsReceivableDetails.vue?vue&type=template&id=80726de4&scoped=true&"
import script from "./AccountsReceivableDetails.vue?vue&type=script&lang=js&"
export * from "./AccountsReceivableDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80726de4",
  null
  
)

export default component.exports